export const PRODUCT_FILTER_COMPOSER = () => [
  {
    name: 'registry',
    title: 'search.tableHeader.anagrafic',
    filterRow: [
      [
        // row 1
        {
          name: 'product-type',
          label: 'search.label.productType',
        },
        {
          name: 'distribution-channel',
          label: 'search.label.distributionChannel',
        },
      ],
      [
        // row 2
        {
          name: 'product-structure',
          label: 'search.label.structure',
        },
        {
          name: 'kiid-type',
          label: 'search.label.kidtype',
        },
        {
          name: 'premium',
          label: 'search.label.premium',
        },
      ],
    ],
  },
  {
    name: 'perimeter',
    title: 'search.label.perimeterConfiguration.perimeter',
    filterRow: [
      [
        {
          col: 3,
          name: 'perimeter-type',
          label: 'search.label.perimeterConfiguration.perimeterType',
        },
        {
          col: 3,
          name: 'perimeter-single-date',
          label: 'search.label.perimeterConfiguration.perimeterSingleDate',
        },
      ],
    ],
  },
  {
    name: 'underlying',
    title: 'productDetails.underlying',
    filterRow: [
      [
        // row 1
        {
          name: 'productUnderlying',
          label: 'search.label.ut',
          col: 4,
        },
        {
          name: 'fundCategory',
          label: 'search.label.fc',
          col: 4,
        },
      ],
    ],
  },
  {
    name: 'services',
    title: 'productDetails.services',
    filterRow: [
      [
        // row 1
        {
          name: 'additionalFeatures',
          label: 'productDetails.services',
          col: 6,
        },
      ],
    ],
  },
  {
    name: 'targetMarket',
    title: 'productDetails.targetMarket',
    filterRow: [
      [
        // row 1
        {
          name: 'tmret',
          label: 'search.label.tmret',
        },
        {
          name: 'tmpro',
          label: 'search.label.tmpro',
        },
      ],
      [
        // row 2
        {
          name: 'tmelco',
          label: 'search.label.tmelco',
        },
        {
          name: 'tmke',
          label: 'search.label.tmke',
        },
      ],
      [
        // row 3
        {
          name: 'tmage',
          label: 'search.label.tmage',
        },
        {
          name: 'tmlcll',
          label: 'search.label.tmlcll',
        },
      ],
      [
        // row 4
        {
          name: 'tmatbl',
          label: 'search.label.tmatbl',
        },
        {
          name: 'tmrt',
          label: 'search.label.tmrt',
        },
      ],
      [
        // row 4
        {
          name: 'tmrp',
          label: 'search.label.tmrp',
        },
        {
          name: 'tmth',
          label: 'search.label.tmth',
        },
      ],
    ],
  },
]

export const INIT_SEARCH_FILTER = () => {
  return {
    pt: null,
    str: null,
    dc: null,
    pr: null,
    fc: null,
    ut: null,
    af: null,

    perSD: null,
    perRD: null,

    //retail
    tmRet: null,
    //professional
    tmPro: null,
    //eligibile counterparty
    tmElCo: null,
    //age lowerbound and upperbound
    tmAgeF: null,
    tmAgeT: null,
    //limited capital loss
    tmlCllF: null,
    tmlCllT: null,
    //knoledge and or experience
    tmke: null,
    //ability to bear loss
    tmatbl: null,
    //market risk tolerance
    tmrt: null,
    //market return profile
    tmrp: null,
    //market time horizon
    tmth: null,
    // kid type
    kidType: null,
  }
}

export const INIT_MONITORING_HISTORY_FILTERS = () => {
  return {
    //product
    productName: null,
    //investment option
    investmentOption: null,
    //driver
    driver: null,
  }
}

export const INIT_COVERAGE_FILTERS_INSIGHTS = () => {
  return {
    //score lowerbound and upperbound
    scoreF: 0,
    scoreT: 1,
    //issuers
    issuers: [],
    //scoring profiles
    compatibility: [],
  }
}

export const INIT_COVERAGE_FILTERS_EDIT = () => {
  return {
    issuers: [],
  }
}

export const INIT_PERIMETER_TYPE = () => {
  return ['0']
}

export const INIT_OPT_SD = () => {
  return {
    optSD: ['1'],
    mad: TODAY(),
  }
}

export const TODAY = () => {
  let today = new Date()
  today.setHours(0, 0, 0, 0)
  return today
}

export const INIT_OPT_RD = () => {
  return {
    optRD: ['1'],
    from: null,
    to: null,
  }
}

export const INIT_SCORING_PROFILE = () => {
  return {
    scoringProfileId: null,
    filters: INIT_SEARCH_FILTER(),
  }
}

export const MODEL_TABS = [
  {
    id: 0,
    title: 'scoringProfilesModelCreate.drivers',
    type: 'TabScoringModelDrivers',
  },
  {
    id: 1,
    title: 'scoringProfilesModelCreate.weights',
    type: 'TabScoringModelWeights',
  },
]

export const INSIGHTS_TABLE_FIELDS = [
  {
    key: 'isUnderTesting',
    label: '',
    class: 'link',
  },
  {
    key: 'score',
    label: 'scoringProfileInsights.tableFields.score',
    class: 'score',
    sortable: true,
  },
  {
    key: 'issuerName',
    label: 'scoringProfileInsights.tableFields.issuer',
    class: 'issuer',
    sortable: true,
  },
  {
    key: 'name',
    label: 'scoringProfileInsights.tableFields.name',
    class: 'name',
    sortable: true,
  },
  {
    key: 'scoringProfile',
    label: 'scoringProfileInsights.tableFields.scoringProfile',
    class: 'scoringProfile',
    sortable: true,
  },
  {
    key: 'details',
    label: '',
    class: 'details',
  },
]

export const SCORING_DEFINITION_TYPES = {
  geometric: 'geometricDrivers',
  custom: 'customDrivers',
  linear: 'linearDrivers',
}

export const INIT_DEFINITION_SETTINGS = () => {
  return {
    1: {
      list: [],
      edit: false,
      slider: true,
      guideline: false,
      config: SCORING_DEFINITION_TYPES.geometric,
    },
    2: {
      list: [],
      edit: true,
      slider: false,
      guideline: true,
      config: SCORING_DEFINITION_TYPES.custom,
    },
    3: {
      list: [],
      edit: false,
      slider: false,
      guideline: false,
      config: SCORING_DEFINITION_TYPES.linear,
    },
  }
}

export const FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
export const FILE_NAME_EXPORT_SID = 'OpenKid-Export-SID.xlsx'
export const FILE_NAME_EXPORT_INVESTMENT_CERTIFICATES = 'OpenKid-Export-InvestmentCertificates.xlsx'
export const FILE_NAME_EXPORT_PRODUCTS = 'OpenKid-Export-Products.xlsx'
export const FILE_NAME_EXPORT_MONITORING = 'OpenKid-Export-Monitoring.xlsx'
export const FILE_NAME_EXPORT_EFFICIENCY_TEST = 'OpenKid-Export-EfficiencyTest.xlsx'
export const FILE_NAME_REPORT_EFFICIENCY_TEST = 'OpenKid-Report-EfficiencyTest.xlsx'
export const EXPORT_MONITORING_ENDPOINT = '/api/scoringMonitoring/export'
